// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","container":"styles_container__3UUOe","checkout":"styles_checkout__3OO9T","cartItemsInModal":"styles_cartItemsInModal__26vTa"};